var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "background" },
    [
      _c("div", { staticClass: "app-container" }, [
        _c("div", { staticClass: "header" }, [
          _c(
            "div",
            { staticClass: "header-title" },
            [
              _c(
                "el-button",
                { staticClass: "midButton", on: { click: _vm.backToIndex } },
                [_vm._v("戻る")]
              ),
              _vm._v(" 請求書確認"),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "app-container" },
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  "header-cell-style": { color: "gray", background: "#DCF2FF" },
                  data: _vm.form,
                  border: "",
                  fit: "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "title", label: "タイトル", align: "left" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  "header-cell-style": { color: "gray", background: "#DCF2FF" },
                  data: _vm.form,
                  border: "",
                  fit: "",
                },
              },
              [
                _c("el-table-column", {
                  attrs: { label: "承認状態", align: "left" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.displayAcceptanceType(
                                  scope.row.is_acceptance,
                                  scope.row.date_of_acceptance
                                )
                              ) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { label: "承認日時", align: "left" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm.form[0].is_acceptance === true
                            ? _c("div", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.displayDateTime(
                                        scope.row.date_of_acceptance,
                                        "YYYY年MM月DD日 HH:mm"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  "header-cell-style": { color: "gray", background: "#DCF2FF" },
                  data: _vm.form,
                  border: "",
                  fit: "",
                },
              },
              [
                _c(
                  "el-table-column",
                  { attrs: { align: "left" } },
                  [[_vm._v("\n             \n          ")]],
                  2
                ),
                _vm._v(" "),
                _c(
                  "el-table-column",
                  { attrs: { label: "取り消し有効期限", align: "left" } },
                  [
                    [
                      _vm.form[0].is_acceptance === true
                        ? _c("div", [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.displayDateTime(
                                    _vm.expiration_date,
                                    "YYYY年MM月DD日"
                                  )
                                ) +
                                "\n            "
                            ),
                          ])
                        : _vm._e(),
                    ],
                  ],
                  2
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("h3", { staticClass: "header-title" }, [_vm._v("請求書内容")]),
            _vm._v(" "),
            _c(
              "el-form",
              {
                ref: "form",
                attrs: { "label-position": "top", "label-width": "250px" },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 50 } },
                  [
                    _c(
                      "el-col",
                      [
                        _c("el-form-item", [
                          _c("iframe", {
                            attrs: {
                              src: _vm.form[0].file_url,
                              width: "100%",
                              height: "800",
                            },
                          }),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.form[0].is_acceptance === false ||
            _vm.form[0].is_acceptance === null
              ? _c("div", [
                  _vm.form[0].date_of_acceptance !== null
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "midButton",
                              on: { click: _vm.backToIndex },
                            },
                            [_vm._v("戻る")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "midButton",
                              attrs: { type: "primary" },
                              on: { click: _vm.approval },
                            },
                            [_vm._v("承認")]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "midButton",
                              on: { click: _vm.backToIndex },
                            },
                            [_vm._v("戻る")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "midButton",
                              attrs: { type: "primary" },
                              on: { click: _vm.approval },
                            },
                            [_vm._v("承認")]
                          ),
                        ],
                        1
                      ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.form[0].is_acceptance === true
              ? _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "midButton",
                        on: { click: _vm.backToIndex },
                      },
                      [_vm._v("戻る")]
                    ),
                    _vm._v(" "),
                    _vm.expiration_flag === false
                      ? _c(
                          "el-button",
                          {
                            staticStyle: {
                              "background-color": "#f00",
                              color: "#fff",
                            },
                            attrs: { type: "info" },
                            on: { click: _vm.cancel },
                          },
                          [_vm._v("承認取り消し")]
                        )
                      : _c(
                          "el-button",
                          { attrs: { disabled: "", type: "primary" } },
                          [_vm._v("承認")]
                        ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _vm.form[0].date_of_acceptance !== null
          ? _c("div", [
              _vm.form[0].is_acceptance === true &&
              _vm.expiration_flag === false
                ? _c("p", { staticStyle: { color: "#f00" } }, [
                    _vm._v(
                      "取り消し有効期限：" +
                        _vm._s(
                          _vm.displayDateTime(
                            _vm.expiration_date,
                            "YYYY年MM月DD日"
                          )
                        )
                    ),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "確認",
            visible: _vm.centerDialogVisible,
            width: "30%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.centerDialogVisible = $event
            },
          },
        },
        [
          _c("span", [_vm._v("請求書の内容を確認した上で承認を行いますか？")]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.centerDialogVisible = false
                    },
                  },
                },
                [_vm._v("いいえ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.approvalProcess },
                },
                [_vm._v("はい")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "確認",
            visible: _vm.centerDialogVisibleCancel,
            width: "30%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.centerDialogVisibleCancel = $event
            },
          },
        },
        [
          _c("span", [_vm._v("請求書の承認取り消しを行いますか？")]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.centerDialogVisibleCancel = false
                    },
                  },
                },
                [_vm._v("いいえ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.cancelProcess },
                },
                [_vm._v("はい")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "確認",
            visible: _vm.waitDialogVisible,
            width: "30%",
            "close-on-click-modal": false,
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.waitDialogVisible = $event
            },
          },
        },
        [_c("span", [_vm._v("承認処理中！")])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }